import { useEffect } from 'react';
import uiStore from '../store/ui-store';

/**
 * Hook pour enregistrer automatiquement un modal dans le système de fermeture globale
 *
 * @param isOpen - État d'ouverture du modal
 * @param onClose - Callback de fermeture du modal
 *
 * @example
 * ```tsx
 * const MyModal = ({ isOpen, onClose }) => {
 *   useAutoCloseModal(isOpen, onClose);
 *
 *   return (
 *     <Modal isOpen={isOpen} onClose={onClose}>
 *       ...
 *     </Modal>
 *   );
 * };
 * ```
 *
 * Quand une erreur de limite est détectée, le hook `useSubscriptionLimit`
 * appellera `uiStore.closeAllModals()` qui fermera automatiquement tous
 * les modals enregistrés via ce hook.
 */
export const useAutoCloseModal = (isOpen: boolean, onClose: () => void) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    // Enregistre le callback de fermeture dans le store
    const unregister = uiStore.registerModalCloseCallback(onClose);

    // Nettoie l'enregistrement quand le modal se ferme ou se démonte
    return unregister;
  }, [isOpen, onClose]);
};
